export class CustomDimensions {
  height: number;
  width: number;

  constructor(init?: Partial<CustomDimensions>) {
    Object.assign(this, init);
  }
}
